// extracted by mini-css-extract-plugin
module.exports = {"formBox":"styles_formBox__3nGLo","setPasswordWrapper":"styles_setPasswordWrapper__2zD3f"};